import React from "react";
import {
    FacebookShareButton,
    TwitterShareButton,
    LinkedinShareButton,
    EmailShareButton,
} from "react-share";
import {FaFacebook, FaTwitter, FaLinkedin, FaEnvelope, FaCopy} from "react-icons/fa";
import {CopyToClipboard} from "react-copy-to-clipboard";

function ShareCard({
                       faceBookSharedConfig,
                       twitterSharedConfig,
                       linkedInSharedConfig,
                       linkSharedConfig,
                       emailSharedConfig
                   }) {
    return (
        <>
            <span className="job-card__share__label">Deel op sociale media</span>
            <ul className='job-card__share social-share-icons__row'>
                <li className="job-card__share__column">
                    <FacebookShareButton
                        {...faceBookSharedConfig}
                    >
                        <FaFacebook/>
                    </FacebookShareButton>
                </li>
                <li className="job-card__share__column">
                    <TwitterShareButton
                        {...twitterSharedConfig}
                    >
                        <FaTwitter/>
                    </TwitterShareButton>
                </li>
                <li className="job-card__share__column">
                    <LinkedinShareButton
                        {...linkedInSharedConfig}
                    >
                        <FaLinkedin/>
                    </LinkedinShareButton>
                </li>
                <li className="job-card__share__column">
                    <EmailShareButton
                        {...emailSharedConfig}
                    >
                        <FaEnvelope/>
                    </EmailShareButton>
                </li>
                <li className="job-card__share__column full-width">
                    <label htmlFor="job-card__share--copy-link" className="job-card__share__label">Of kopieer de
                        link</label>
                    <div className="job-card__share__row">
                        <input id="job-card__share--copy-link" className="job-card__share__copy--input"
                               defaultValue={linkSharedConfig.url}/>
                        <CopyToClipboard
                            text={linkSharedConfig.url}
                            title="Copy link">
                            <button className={`react-share__ShareButton ShareButton--copy`}>
                                <FaCopy/>
                            </button>
                        </CopyToClipboard>
                    </div>
                </li>
            </ul>
        </>
    );
}

export default ShareCard;
